import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, Download, Eye, Printer } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import DatePicker from 'react-datepicker';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5 } from "../../../AbstractElements";
import axios from "axios";
import { FontSize } from "../../../Constant";

const user_options = ["Name", "Province", "District", "Created Date"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
  startDate,
  handleChange,
}) => (
  <div style={{ display: "flex", flexDirection: "row", width: '100%', gap: 10 }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
    {userOption === 'Created Date'?
              <DatePicker className="form-control digits" showPopperArrow={false} selected={startDate} showTimeSelect dateFormat="Pp" onChange={handleChange} />
    : <>
      <input
          className="form-control"
          placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province") : t("Filter by Status") }
          aria-label="Search Input"
          style={{ width: "250px", paddingLeft: "5px" }}
          name="phone"
          id="search"
          type="text"
          value={filterText}
          onChange={onFilter}
        />
        <Btn attrBtn={{ onClick: onClear }} type="button">
          X
        </Btn>
    </>
    }
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [user_id, setUserId] = useState();
  const { t } = useTranslation();
  const [startDate, setstartDate] = useState(
    new Date()
  );
  const pres = localStorage.getItem("pres");
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Name");
  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
  }, []);

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        "https://api-portal.nada.org.np/api/proxies/proxy/attendance",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response2?.data?.success) {
        setData(response2?.data?.data?.attendance);
        setFilteredItems(response2?.data?.data?.attendance);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);


  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };


  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name of Firm"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Phone Number"),
      selector: (Row) => Row["phone_number"],
      sortable: true,
      center: true,
    },
    {
      name: t("Crated Date"),
      selector: (Row) => Row["date"],
      sortable: true,
      center: true,
    },
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

    const handleChange = date => {
      setstartDate(date);
      setFilterText(date.toISOString().split('T')[0])
    };

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_firm
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "Created Date"
          ? data?.filter((item) => {
            const dbDate = new Date(item?.date);
            const selectedDate = new Date(startDate);
            return (
                dbDate.getFullYear() === selectedDate.getFullYear() &&
                dbDate.getMonth() === selectedDate.getMonth() &&
                dbDate.getDate() === selectedDate.getDate()
            )})
          : data?.filter((item) =>
            String(item?.status === 1? 'Submitted' : item?.status === 2?  'Send For Edits' : item?.status === 3?  'Accepted' : item?.status === 4?  'Rejected' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
        startDate={startDate}
        handleChange={handleChange}
      />
    );
  }, [filterText, resetPaginationToggle, startDate, userOption, data, t]);

  const exportToExcel = (e) => {
    e.preventDefault();
    if(filteredItems.length !== 0) {
    // Convert JSON data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredItems);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a binary string representation of the workbook
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the binary data
    const blob = new Blob([wbout], { type: 'application/octet-stream' });

    // Save the file using file-saver
    saveAs(blob, 'data.xlsx');
    } else {
      toast.error('No data to export');
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Attendance")}</H5>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Btn
                    attrBtn={{ color: "secondary", onClick: (e) => exportToExcel(e) }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("export as csv")}
                  </Btn>
                </div>
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default DataTablesContain;
